/**
 * Utility functions for managing debug functionality access on the client side
 */

/**
 * Allowed hostnames for debug functionality
 */
const ALLOWED_DEBUG_HOSTNAMES = [
  'test.netflixstudios.com',
  'test.netflix.net',
  'localhost'
];

/**
 * Checks if debug functionality should be enabled based on the current hostname
 */
export function isDebugEnabled(): boolean {
  const hostname = window.location.hostname;
  return ALLOWED_DEBUG_HOSTNAMES.some(allowedHostname => hostname.endsWith(allowedHostname));
}